var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelgram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 27,
    height: 27,
    rx: 6,
    fill: "#0D3754"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1355 11.1052C25.3568 11.0121 25.5991 10.9799 25.837 11.0122C26.0749 11.0444 26.2999 11.1398 26.4884 11.2885C26.677 11.4372 26.8222 11.6337 26.9091 11.8576C26.9959 12.0814 27.0212 12.3245 26.9822 12.5614L24.951 24.8819C24.754 26.0703 23.45 26.7518 22.3601 26.1598C21.4484 25.6646 20.0943 24.9016 18.8763 24.1054C18.2673 23.7069 16.4018 22.4307 16.6311 21.5225C16.8281 20.7461 19.9627 17.8283 21.7538 16.0936C22.4568 15.412 22.1362 15.0189 21.306 15.6458C19.2444 17.2023 15.9344 19.5693 14.84 20.2356C13.8745 20.8231 13.3712 20.9234 12.7694 20.8231C11.6714 20.6404 10.6531 20.3574 9.82204 20.0126C8.69899 19.5469 8.75362 18.0029 9.82114 17.5534L25.1355 11.1052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelgram);
export default __webpack_public_path__ + "static/media/telgram.ab4cc5bf0ee65c04922f389c1ee7af6b.svg";
export { ForwardRef as ReactComponent };